var map = {
	"./br/PT/S1/bg_p117.jpg": 66172,
	"./br/PT/bg_p117.jpg": 91393,
	"./in/EN/S1/bg_p117.jpg": 33603,
	"./ph/EN/S1/bg_p117.jpg": 67165,
	"./ph/EN/bg_p117.jpg": 25403,
	"./vn/VI/S1/bg_p117.jpg": 11773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32179;